import {ApolloClient} from 'apollo-boost';
import {createHttpLink} from 'apollo-link-http';
import {setContext} from 'apollo-link-context';
import {InMemoryCache} from 'apollo-cache-inmemory';

const httpLink = (isNest) => {
  const {REACT_APP_NEST_GRAPHQL_END_POINT, REACT_APP_ECOBEE_GRAPHQL_END_POINT} = process.env;
  const uri = isNest ? REACT_APP_NEST_GRAPHQL_END_POINT : REACT_APP_ECOBEE_GRAPHQL_END_POINT;
  return createHttpLink({uri});
}

const withAuthLink = (awairAccessToken) => setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      authorization: awairAccessToken ? `Bearer ${awairAccessToken}` : '',
    }
  }
});

let apolloClient = null;

export const getApolloClient = () => {
  return apolloClient;
};

export const setApolloClient = (awairAccessToken , isNest) => {
  apolloClient = new ApolloClient({
    link: withAuthLink(awairAccessToken).concat(httpLink(isNest)),
    cache: new InMemoryCache()
  });
};


// WEBPACK FOOTER //
// ./src/lib/graphQL/apolloClient.js